<label class="agpr-briefingChartDimensionsField-label">
    {{ 'PageBuilder.blockType.chart.settings.chartSize' | localize }}
</label>
<div class="agpr-briefingChartDimensionsField-section">
    <label
        class="agpr-briefingChartDimensionsField-inputLabel"
        id="chart_width_label"
    >
        {{ 'PageBuilder.blockType.chart.settings.width' | localize }}
    </label>
    <agpr-slider-input
        class="agpr-briefingChartDimensionsField-width"
        [id]="'chart_width_slider'"
        [showMinMaxLabels]="true"
        [ariaValueText]="widthPercent + '%'"
        ariaLabelledBy="chart_width_label"
        [min]="30"
        [max]="100"
        [step]="1"
        [ngModel]="widthPercent"
        (ngModelChange)="chartWidthChanged($event)"
    ></agpr-slider-input>
    <agpr-number-input
        class="agpr-briefingChartDimensionsField-height"
        [id]="'chart_height_numberInput'"
        label="PageBuilder.blockType.chart.settings.height"
        placeholder="PageBuilder.blockType.chart.settings.height.placeholder"
        [min]="100"
        [max]="1000"
        unit="px"
        [integerOnly]="true"
        ariaLabelledBy="chart_height_label"
        [(ngModel)]="value.heightPx"
        (ngModelChange)="chartHeightChanged($event)"
        (blur)="chartHeightEmitted()"
    ></agpr-number-input>
</div>
